import { delayedCall, dispatcher, ingenuity, killDelayedCall, SpineBase } from "@quest/base-core";
import { SlotEventConstantsBehavior, WinPresentationPanelBehavior } from "@quest/murka-games-behavior-panther";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";

export class WinPresentationPanelGame extends WinPresentationPanelBehavior {
  subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.START_BONUS_WIN_ANIM, this.playBonusWinAnimations, this);
    dispatcher.on(eventDispatchers.REMOVE_BONUS_FROM_WINPRESENTATION, this.removeBonusSymFromWinPresentation, this);
  }

  unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.START_BONUS_WIN_ANIM, this.playBonusWinAnimations, this);
    dispatcher.off(eventDispatchers.REMOVE_BONUS_FROM_WINPRESENTATION, this.removeBonusSymFromWinPresentation, this);
  }

  protected continueNextLineToggle(): void {
    if (this.model.nextWinAnimIndex < this.model.winLineDataLength) {
      this.model.playLineWinAnim = true;
      this.animateLineToggle();
    } else {
      this.stopAllWinAnimations();
      this.oneToggleCompletes = true;
      if (
        (ingenuity.parserModel as GameParserModel).getHasScatterWins() ||
        (ingenuity.parserModel as GameParserModel).getTriggerScatterWinData().length > 0 ||
        (ingenuity.parserModel as GameParserModel).getHasFreeGamesWin() ||
        (ingenuity.parserModel as GameParserModel).getHoldAndRespinStatus()
      ) {
        this.winCycleCompleted();
      } else if (this.toggleingContinue) {
        this.model.resetCurrentWinAnimIndex();
        this.animateLineToggle();
      } else {
        this.winCycleCompleted();
      }
    }
  }

  /**
   * to play bonus symbol triggering animation
   */
  protected playBonusWinAnimations(evt: any): void {
    const bonusWinData = evt.data;
    let i;
    let symbolID;
    if (ingenuity.configData.animationStopInScatterwin) {
      this.stopAllWinAnimations();
    }
    for (i = 0; i < bonusWinData.length; i++) {
      const row: number = bonusWinData[i].offSet[0];
      const col: number = bonusWinData[i].offSet[1];
      symbolID = this.model.getReelGridElement(row, col);
      this.playSymbolTriggerAnimationByID(symbolID, row, col, "bonuswin");
      const symbol = this.reelPanel.getSymbolByPos(row, col);
      let bonusWonText: SpineBase = symbol.getAnimation().children[symbol.getAnimation().children.length - 1];
      bonusWonText.playAnim("bonuswon_text");
      dispatcher.fireEvent(eventDispatchers.PLAY_WIN_ANIM_LEFT_CHARACTER);
    }
    delayedCall(
      SlotConstants.TimerScatterAnimationEnded,
      gameConstants.TIME_BONUS_ANIMATION_END,
      function () {
        killDelayedCall(SlotConstants.TimerScatterAnimationEnded);
        dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
      },
      this
    );
  }

  private removeBonusSymFromWinPresentation() {
    this.reelPanel.showAllSymbols();
    this.clearSymReels();
  }

  // Overrided to pass current win line offset for stack win line animation handling
  protected showWinLine(winLineData: any, currentWinLine: any): void {
    if (winLineData && winLineData[currentWinLine]) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_WAY_WIN_AMT, winLineData[currentWinLine]);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_WAY_WIN_AMT_FG, winLineData[currentWinLine]);
    }
    killDelayedCall(SlotConstants.TimerAnimateNextWinLine);
    if (
      (ingenuity.parserModel as GameParserModel).getStackSymPresent() &&
      (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin().length > 0 &&
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState
    ) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_STACK_WIN_ANIMATION_ON_TOGGLE, winLineData[currentWinLine].positions);
    }
    ingenuity.configData.startAnimationOnCurrentWinLine = true;
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstants.FG_LINE_ANIMATION_STARTED, winLineData[currentWinLine]);
      dispatcher.fireEvent(SlotEventConstants.FG_START_PAYLINE_MASK_MOVE, {
        duration: this.WIN_LINE_ANIM_TIMEOUT,
        lineData: winLineData[currentWinLine],
      });
    } else {
      dispatcher.fireEvent(SlotEventConstants.LINE_ANIMATION_STARTED, winLineData[currentWinLine]);
      dispatcher.fireEvent(SlotEventConstants.START_PAYLINE_MASK_MOVE, {
        duration: this.WIN_LINE_ANIM_TIMEOUT,
        lineData: winLineData[currentWinLine],
      });
    }
    console.info("%c Line win started event for %d line", "background:AntiqueWhite; color:Aqua", winLineData[currentWinLine].id);
    delayedCall(SlotConstants.TimerAnimateNextWinLine, this.WIN_LINE_ANIM_TIMEOUT, this.animateNextWinLine, this);
  }
}
